/** The report query and its addendum-chain list for a sync key ('std:' / 'tc:'). */
export function reportQueryKeysFor(reportKey) {
    const colon = reportKey.indexOf(':');
    if (colon < 0)
        return null;
    const kind = reportKey.slice(0, colon);
    const id = reportKey.slice(colon + 1);
    if (!id)
        return null;
    if (kind === 'std')
        return { report: ['report', id], chain: ['study-reports', id] };
    if (kind === 'tc')
        return { report: ['tc-report', id], chain: ['tc-case-reports', id] };
    return null;
}
/**
 * Patch the cached report with what the server wrote, then invalidate it and
 * its chain: an open query refetches at once (dropping a fetch that may have
 * read the row before the write committed), and a closed one is stale, so the
 * next editor to mount reads the row instead of trusting the cache.
 */
export function applyAnnouncedContentKeys(queryClient, reportKey, patch) {
    const keys = reportQueryKeysFor(reportKey);
    if (!keys)
        return;
    queryClient.setQueryData(keys.report, (old) => old ? { ...old, content: { ...old.content, ...patch } } : old);
    void queryClient.invalidateQueries({ queryKey: keys.report });
    void queryClient.invalidateQueries({ queryKey: keys.chain });
}
